import React from 'react'

function Blueprint() {
   return (
      <section id="projects-list" className="cs-bg-secondary">
         <div className="container">
            <div className="container">
               <h2 className="section_heading_title mb-3 tech_title">
                  Blueprint to Success: <br /> Navigating Key Work Process
                  Stages
               </h2>

               <p className="section_desc">
                  Our journey starts with discovery, where we deeply understand
                  your vision and goals. From there, we craft a strategic plan
                  and design a seamless experience tailored to your needs. Our
                  expert developers then bring your project to life with
                  precision and innovation. Thorough QA guarantees impeccable
                  execution prior to launch of your solution. But that's not
                  where we stop—instead, we remain by your side with continuing
                  support, all running like clockwork.
               </p>
            </div>
            <div className="container-fluid work_process text-center">
               <div className="item item-first">
                  <div className="arrow-left">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M208.077 4.58008H129.706C69.51 4.58008 20.7227 53.476 20.7227 113.79V118.633"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M20.7285 144.792C16.1688 132.482 8.3936 117.21 0.157227 107.744L20.7285 115.22L41.2962 107.744C33.0598 117.21 25.2811 132.482 20.7285 144.792Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item text-start item-first">
                  <div>
                     <div className="circle">
                        <span>1</span>
                     </div>
                     <span className="process-main-title">
                        Meeting & Listening
                     </span>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">MEETING &amp; LISTENING</h2>
                     <p className="process-desc">
                        By engaging in an in-depth discussion, we identify key
                        project goals and any potential challenges. This direct
                        conversation helps eliminate misunderstandings and sets
                        a solid foundation for the project, ensuring that our
                        approach aligns perfectly with your expectations. This
                        stage addresses the common pain point of misaligned
                        objectives, ensuring we start on the right foot with
                        clear, mutual agreements.
                     </p>
                  </div>
               </div>
               <div className="item text-end">
                  <div>
                     <span className="process-main-title">
                        Project Requirements
                     </span>
                     <div className="circle">
                        <span>2</span>
                     </div>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">Project Requirements</h2>
                     <p className="process-desc">
                        Then, we move further into the nitty-gritty by
                        specifying the project scope and requirements. We
                        segment your needs into actionable steps, identify the
                        needed resources, and provide a schedule. This is how we
                        address the issue of ambiguous project scopes that
                        result in scope creep, by setting clear limits and
                        defined deliverables. This accuracy avoids future
                        differences and makes both parties have congruent
                        expectations.
                     </p>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-right">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M0.708984 4.46484H79.0757C139.272 4.46484 188.06 53.3616 188.06 113.674V118.518"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M188.061 144.676C183.504 132.367 175.726 117.095 167.489 107.628L188.061 115.083L208.628 107.617C200.402 117.095 192.613 132.367 188.061 144.676Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-left">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M208.077 4.58008H129.706C69.51 4.58008 20.7227 53.476 20.7227 113.79V118.633"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M20.7285 144.792C16.1688 132.482 8.3936 117.21 0.157227 107.744L20.7285 115.22L41.2962 107.744C33.0598 117.21 25.2811 132.482 20.7285 144.792Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item text-start">
                  <div>
                     <div className="circle">
                        <span>3</span>
                     </div>
                     <span className="process-main-title">
                        Submit The Offer
                     </span>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">Submit The Offer</h2>
                     <p className="process-desc">
                        Once we have a clear picture and documentation of your
                        requirements, we create an offer consisting of
                        timelines, costs, and project methodologies. This step
                        tackles the pain point of cost cutting and budget
                        planning, giving you a clear and detailed proposal so
                        that you can make an informed decision. This way, you
                        can establish your budget and expectations upfront and
                        prevent any surprises.
                     </p>
                  </div>
               </div>
               <div className="item text-end">
                  <div>
                     <span className="process-main-title">OFFER APPROVAL</span>
                     <div className="circle">
                        <span>4</span>
                     </div>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">OFFER APPROVAL</h2>
                     <p className="process-desc">
                        At the offer approval phase, there is a focus on
                        agreeing mutually on the terms of the project. This
                        phase addresses the issue of commitment and consent,
                        having both parties comfortable and assured with the way
                        ahead. It provides a clear course of action, which is
                        paramount in sustaining project momentum and earning
                        client trust and commitment.
                     </p>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-right">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M0.708984 4.46484H79.0757C139.272 4.46484 188.06 53.3616 188.06 113.674V118.518"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M188.061 144.676C183.504 132.367 175.726 117.095 167.489 107.628L188.061 115.083L208.628 107.617C200.402 117.095 192.613 132.367 188.061 144.676Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-left">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M208.077 4.58008H129.706C69.51 4.58008 20.7227 53.476 20.7227 113.79V118.633"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M20.7285 144.792C16.1688 132.482 8.3936 117.21 0.157227 107.744L20.7285 115.22L41.2962 107.744C33.0598 117.21 25.2811 132.482 20.7285 144.792Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item text-start">
                  <div>
                     <div className="circle">
                        <span>5</span>
                     </div>
                     <span className="process-main-title"> DESIGN </span>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">DESIGN</h2>
                     <p className="process-desc">
                        During the design phase, strategy and creativity
                        collide. Our designers create a visual identity that
                        captures your brand and addresses the project's
                        functional needs. Here, we solve the dilemma of
                        aesthetic mismatch by ensuring the design appeals to
                        your audience but still retains your brand character.
                        Through the provision of options and iterations, we
                        guarantee the final design is something that you believe
                        best captures your idea.
                     </p>
                  </div>
               </div>
               <div className="item text-end">
                  <div>
                     <span className="process-main-title">
                        DESIGN VALIDATION
                     </span>
                     <div className="circle">
                        <span>6</span>
                     </div>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">DESIGN VALIDATION</h2>
                     <p className="process-desc">
                        Finally, the design validation phase is where we
                        finalize the designs with your approval, ensuring
                        everything is set for development. This stage tackles
                        the pain point of potential reworks during development
                        by making sure the design is locked down and approved.
                        This minimizes changes during the coding phase, which
                        can be costly and time-consuming, ensuring the project
                        remains on schedule and within budget.
                     </p>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-right">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M0.708984 4.46484H79.0757C139.272 4.46484 188.06 53.3616 188.06 113.674V118.518"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M188.061 144.676C183.504 132.367 175.726 117.095 167.489 107.628L188.061 115.083L208.628 107.617C200.402 117.095 192.613 132.367 188.061 144.676Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-left">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M208.077 4.58008H129.706C69.51 4.58008 20.7227 53.476 20.7227 113.79V118.633"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M20.7285 144.792C16.1688 132.482 8.3936 117.21 0.157227 107.744L20.7285 115.22L41.2962 107.744C33.0598 117.21 25.2811 132.482 20.7285 144.792Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item text-start">
                  <div>
                     <div className="circle">
                        <span>7</span>
                     </div>
                     <span className="process-main-title">DEVELOPMENT</span>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">DEVELOPMENT</h2>
                     <p className="process-desc">
                        Here is where we begin coding and developing the actual
                        product out of the completed designs and specifications.
                        This phase eliminates the pain point of converting
                        design into working, user-friendly software. It's
                        essential because this is where we make sure that the
                        aesthetic and functional aspects of the project are
                        integrated correctly. By doing this in-house, we prevent
                        discrepancies between what was designed.
                     </p>
                  </div>
               </div>
               <div className="item text-end">
                  <div>
                     <span className="process-main-title">PRE-LAUNCH TEST</span>
                     <div className="circle">
                        <span>8</span>
                     </div>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">PRE-LAUNCH TEST</h2>
                     <p className="process-desc">
                        This step addresses the pain area of undiscovered bugs
                        and usability issues. It includes thorough testing of
                        the entire system to make sure everything works as
                        expected on various devices and platforms. This testing
                        process ensures any last-minute changes that must be
                        implemented, preventing the usual mistake of releasing a
                        flawed or sub-optimal product. Proper testing means a
                        better user experience and less need for emergency fixes
                        after launch.
                     </p>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-right">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M0.708984 4.46484H79.0757C139.272 4.46484 188.06 53.3616 188.06 113.674V118.518"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M188.061 144.676C183.504 132.367 175.726 117.095 167.489 107.628L188.061 115.083L208.628 107.617C200.402 117.095 192.613 132.367 188.061 144.676Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item">
                  <div className="arrow-left">
                     <svg
                        width="209"
                        height="145"
                        viewBox="0 0 209 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                     >
                        <path
                           d="M208.077 4.58008H129.706C69.51 4.58008 20.7227 53.476 20.7227 113.79V118.633"
                           stroke="#1F473E"
                           strokeWidth="8.75"
                           strokeMiterlimit="10"
                        />
                        <path
                           d="M20.7285 144.792C16.1688 132.482 8.3936 117.21 0.157227 107.744L20.7285 115.22L41.2962 107.744C33.0598 117.21 25.2811 132.482 20.7285 144.792Z"
                           fill="#1F473E"
                        />
                     </svg>
                  </div>
               </div>
               <div className="item text-start">
                  <div>
                     <div className="circle">
                        <span>9</span>
                     </div>
                     <span className="process-main-title"> LAUNCH </span>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">LAUNCH</h2>
                     <p className="process-desc">
                        The launch stage is the thrilling phase when your
                        project launches to the public. This stage addresses the
                        pain point of moving from a development environment to a
                        live environment, which can usually be filled with
                        unforeseen issues. We make the rollout smooth, including
                        final testing and the configuration of live servers.
                        Launching is not merely putting the project out there;
                        it's about making sure that it works well in actual
                        conditions and provides the desired user experience from
                        day one.
                     </p>
                  </div>
               </div>
               <div className="item text-end">
                  <div>
                     <span className="process-main-title">
                        MAINTENANCE & SUPPORT
                     </span>
                     <div className="circle">
                        <span>10</span>
                     </div>
                  </div>
                  <div className="process-detail">
                     <h2 className="process-title">MAINTENANCE & SUPPORT</h2>
                     <p className="process-desc">
                        Updates, problem patches, and potential scaling as your
                        user base increases are all covered in this last step.
                        The website is kept secure, functional, and current with
                        the newest web standards and technology through ongoing
                        support. The issue of the website becoming outdated or
                        susceptible over time is resolved in this step, giving
                        you the assurance that your investment is safeguarded
                        and may change to meet your company's demands.
                     </p>
                  </div>
               </div>
            </div>
         </div>
      </section>
   )
}

export default Blueprint
